import React from "react";

export default interface Faq {
    question: string
    answer: string
    id: number,
    category: FaqCategory
}

export enum FaqCategory {
    LoginAndSignUp = 1,
    Order = 2,
    Products = 3,
    Payment = 4,
    Shipping = 5,
    ReturnAndExchange = 6,
}

export const FaqCategoryName = {
    [FaqCategory.LoginAndSignUp]: 'ورود و ثبت‌نام',
    [FaqCategory.Order]: 'سفارش',
    [FaqCategory.Products]: 'کالا‌ها',
    [FaqCategory.Payment]: 'پرداخت',
    [FaqCategory.Shipping]: 'ارسال',
    [FaqCategory.ReturnAndExchange]: 'بازگشت و تعویض',
}

export interface FaqItemProps extends Faq {
    expandedAccordion: boolean;
    handleChange: (event: React.SyntheticEvent, expanded: boolean) => void;
    handleEdit: (faq: Faq) => void;
}
